
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class WrzjhTable extends Vue {
    //万人炸金花
    table = {
        data: [],
        column: [
            {
                key: 'dealer',
                title: ' 庄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.dealer) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.dealer.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.dealer.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'sky',
                title: '天(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.sky) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.sky.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.sky.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'land',
                title: '地(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.land) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.land.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.land.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '玄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.black) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.black.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.black.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'yellow',
                title: '黄(投注+牌型)',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hits.hits.yellow) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hits.hits.yellow.bet)
                    }
                    let poker = []
                    if (JSON.parse(params.row.opt_detail).award_content) {
                        poker = JSON.parse(params.row.opt_detail).award_content.point.yellow.poker
                    }
                    return h('div', [
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red',
                                    height: '20px'
                                }
                            },
                            str
                        ),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: poker.map((x, index) => {
                                    return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                })
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '总投注',
                align: 'center',
                render: (h, params) => {
                    let str = 0
                    let arr = JSON.parse(params.row.opt_detail).hits.hits
                    for (const key in arr) {
                        str += (this as any).getMoney(arr[key].bet, 1)
                    }
                    return h('span', str.toFixed(2))
                }
            },
            {
                key: 'black',
                title: '总返奖',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(params.row.chang_point)
                    let color = '#333'
                    if (str > 0) {
                        color = 'red'
                    } else if (str < 0) {
                        color = 'blue'
                    }
                    return h(
                        'span',
                        {
                            style: {
                                color: color
                            }
                        },
                        str
                    )
                }
            }
        ]
    }

    @Prop()
    listdata
}
